import { render, staticRenderFns } from "./tableEditPersonLabel.vue?vue&type=template&id=124fd659&scoped=true&"
import script from "./tableEditPersonLabel.vue?vue&type=script&lang=js&"
export * from "./tableEditPersonLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124fd659",
  null
  
)

export default component.exports